import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import Link from 'components/Link';
import Icon from 'components/Icon';
import './Button.css';

class Button extends React.Component {
  handleKeyPress = event => {
    if (event.key === 'Enter') {
      this.props.onClick();
    }
  };

  render() {
    const {
      children,
      onClick,
      type = Button.TYPES.DEFAULT,
      icon,
      quiet,
      small,
      full,
      confirmation,
      disabled,
      lower,
      className,
    } = this.props;

    return (
      <Link
        onClick={onClick}
        onKeyPress={this.handleKeyPress}
        role="button"
        className={cx(
          {
            Button: true,
            [`Button--${type}`]: true,
            'Button--icon': icon,
            'Button--quiet': quiet,
            'Button--small': small,
            'Button--full': full,
            'Button--confirmation': confirmation,
            'Button--disabled': disabled,
            'Button--lower': lower,
          },
          className
        )}
      >
        {icon ? (
          <div className="Button__Icon">
            <Icon icon={icon} />
          </div>
        ) : null}
        {children}
      </Link>
    );
  }
}

Button.TYPES = {
  DEFAULT: 'default',
  ALT: 'alt',
  SECONDARY: 'secondary',
  WARNING: 'warning',
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.oneOf(Object.values(Button.TYPES)),
  icon: PropTypes.node,
  quiet: PropTypes.bool,
  small: PropTypes.bool,
  full: PropTypes.bool,
  confirmation: PropTypes.bool,
  disabled: PropTypes.bool,
  lower: PropTypes.bool,
};

export default Button;
